import {
  type PermissionItem,
  type UserEntity,
  type UserEntityPermissionsRoleType,
} from "@/api/__generated__/orval/auth";

type SimpleUserPermissions = {
  [key: string]:
    | {
        permissions?: PermissionItem[];
        roleType?: UserEntityPermissionsRoleType;
        roleName?: string;
        organizationPartnership?: string | null;
      }
    | undefined;
};

export const getFlattenPermissions = (
  user?: UserEntity | null,
  removeReadOnly = false
): SimpleUserPermissions => {
  const flattenPermissions: SimpleUserPermissions = {};

  if (!user) {
    return flattenPermissions;
  }

  Object.entries(user.permissions || {}).forEach(
    ([accountKey, accountPermissions]) => {
      if (!accountPermissions) {
        return;
      }

      flattenPermissions[accountKey] = {
        permissions: accountPermissions.permissions,
        roleType: accountPermissions.roleType,
        roleName: accountPermissions.roleName,
      };

      Object.entries(accountPermissions.organizations || {}).forEach(
        ([orgaKey, orgaPermissions]) => {
          if (!orgaPermissions) {
            return;
          }

          flattenPermissions[orgaKey] = {
            permissions: orgaPermissions.permissions,
            roleType: orgaPermissions.roleType,
            roleName: orgaPermissions.roleName,
          };

          Object.entries(orgaPermissions.workspaces || {}).forEach(
            ([workspaceKey, workspacePermissions]) => {
              if (!workspacePermissions) {
                return;
              }

              flattenPermissions[workspaceKey] = {
                permissions: workspacePermissions.permissions,
                roleType: workspacePermissions.roleType,
                roleName: workspacePermissions.roleName,
                organizationPartnership:
                  workspacePermissions.organizationPartnership,
              };
            }
          );
        }
      );
    }
  );

  if (removeReadOnly) {
    const flattenPermissionsWithoutRemoveReadOnly: SimpleUserPermissions = {};
    Object.entries(flattenPermissions).forEach(
      ([accountKey, accountPermissions]) => {
        if (accountPermissions?.roleName?.includes("read only")) {
          return;
        }
        flattenPermissionsWithoutRemoveReadOnly[accountKey] =
          accountPermissions;
      }
    );
    return flattenPermissionsWithoutRemoveReadOnly;
  }

  return flattenPermissions;
};
